import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { images } from "../../assets/images";
import login from "../../services/authService";
import registerDevice from "../../services/deviceService";

const LoginScreen = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const role = localStorage.getItem("role");
    if (token) {
      navigate(role === "super_admin" ? "/super-admin-dashboard" : "/dashboard", { replace: true });
    }
  }, []);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    const doLogin = async () => {
      const res = await login(email, password);
      const accessToken = res.data.response.accessToken;
      const refreshToken = res.data.response.refreshToken;
      const role = res.data.response.user.role;
      const companyPid = res.data.response.user.companyPid;
      const projectPid = res.data.response.user.projectPid;
      localStorage.setItem('token', accessToken);
      localStorage.setItem('refreshToken', refreshToken);
      localStorage.setItem('role', role);
      if (companyPid) localStorage.setItem('companyPid', companyPid);
      if (projectPid) localStorage.setItem('projectPid', projectPid);
      if (role === 'super_admin') {
        navigate("/super-admin-dashboard");
      } else if (role === 'project_admin') {
        navigate("/dashboard");
      }
    };

    try {
      if (!localStorage.getItem('devicePid')) {
        await registerDevice();
      }
      await doLogin();
    } catch (err) {
      const msg = err?.response?.data?.message || "";
      setError(msg || "Login failed. Please try again.");
    }
  };

  return (
    <section className="login-section-bg">
      <div className="container-main">
        <div className="d-flex justify-content-center mb-2">
          <div className="auth-logo">
            <img
              src={images.logoHorizontal}
              alt="app-logo"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = images.appLogo;
              }}
            />
          </div>
        </div>

        <div className="card auth-card">
          <h4 className="fw-semibold text-center fs-20 mb-1">Welcome Back</h4>
          <p className="mb-3 text-muted text-center fs-13">
            Sign in to access your workspace and continue seamlessly.
          </p>
          <form className="login-form mt-2" onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">
                Email
                <span className="text-danger"> *</span>
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="form-control input-tags"
                placeholder="Enter email"
              />
            </div>
            <div className="mb-2">
              <label className="form-label">
                Password
                <span className="text-danger"> *</span>
              </label>

              <div className="form-group position-relative mb-2">
                <input
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="form-control input-tags input-tags-grouped"
                  placeholder="Enter password"
                />
                <span
                  className="eye-icon"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <i
                    className={`fa-solid ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
                  ></i>
                </span>
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-between">
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input cursor-pointer"
                  id="rememberMe"
                />
                <label className="fs-15" htmlFor="rememberMe">
                  Remember me
                </label>
              </div>
              <div
                className="text-end cursor-pointer"
                onClick={() => navigate("/forgot-password")}
              >
                <p className="mb-0 text-primary fw-medium fs-15">
                  Forgot Password?
                </p>
              </div>
            </div>

            {error && (
              <p className="text-danger fs-13 mt-2 mb-0">{error}</p>
            )}
            <div className="mt-4 text-center">
              <button type="submit" className="btn btn-primary w-100 mt-1">
                Login
              </button>
            </div>

            <div className="mt-3 text-center">
              <p className="fs-13 text-muted mb-0">
                By continuing, you agree to our{" "}
                <span
                  className="text-primary fw-medium cursor-pointer"
                  onClick={() => navigate("/terms")}
                >
                  Terms & Conditions
                </span>{" "}
                and{" "}
                <span
                  className="text-primary fw-medium cursor-pointer"
                  onClick={() => navigate("/privacy")}
                >
                  Privacy Policy
                </span>
                .
              </p>
            </div>
          </form>
        </div>
        <p className="position-relative text-center fs-13 mb-0 mt-3 text-muted">
          © {new Date().getFullYear()} AI Project. All Rights Reserved.
        </p>
      </div>
    </section>
  );
};

export default LoginScreen;
